import { ActionHandler } from 'action-handler';

const stateProp = 'pendingTileInstalls';

export default new ActionHandler({
  name: 'set_pending_tile_installs',
  stateProp,
  defaultState: {
    [stateProp]: []
  },
  handler: (appId, isPending) => ({
    appId,
    isPending
  }),
  reduce: (state, { appId, isPending }) => {
    let newState;
    if (isPending) {
      newState = {
        [stateProp]: [...state[stateProp], appId]
      };
    } else {
      newState = {
        [stateProp]: state[stateProp].filter((el) => el !== appId)
      };
    }

    return newState;
  }
});
